import { createContext, useMemo } from 'react';

const defaultContext = { numberOfEvents: 0 };
const EventListContext = createContext(defaultContext);

/**
 * Context and provider for {@link Mojito.Modules.EventList | EventList}.
 *
 * @class EventListContext
 * @memberof Mojito.Modules.EventList
 */

/**
 * EventListContext provider.
 *
 * @function EventListContextProvider
 *
 * @param {object} props - The properties passed to the context provider.
 * @param {number} props.numberOfEvents - Number of events.
 * @param {node|Array<node>} props.children - Children to be wrapped by context provider.
 * @returns {React.ReactElement} React element to be rendered.
 * @memberof Mojito.Modules.EventList.EventListContextProvider
 */
const EventListContextProvider = ({ numberOfEvents, children }) => {
    const value = useMemo(() => ({ numberOfEvents }), [numberOfEvents]);
    return <EventListContext.Provider value={value}>{children}</EventListContext.Provider>;
};

export { EventListContext, EventListContextProvider };
